import { useTheme } from "@mui/material";
import { round } from "lodash-es";
import {
  LegendColorMapRampEntry,
  useTextMaxWidth,
  LegendSymbolizerRasterInterval,
} from "../../hooks/legendHooks";

interface Props {
  symbolizer: LegendSymbolizerRasterInterval;
}

export function LegendSymbolizerItemRasterInterval(props: Props) {
  const {
    symbolizer: { Raster },
  } = props;
  const theme = useTheme();
  const fontSize = theme.typography.fontSize;
  const fontFamily = theme.typography.fontFamily;
  const {
    colormap: { entries },
  } = Raster;
  const { length } = entries;
  const height = fontSize * length * 1.5;
  const entryHeight = height / length;
  const maxTextWidth = useTextMaxWidth(
    entries.map((entry, i) => renderLabel(entry, i)),
    fontSize,
    fontFamily || "Arial"
  );

  function renderLabel(entry: LegendColorMapRampEntry, index: number) {
    const parts = new Array<string>();
    parts.push(entry.label || round(entry.quantity, 2).toLocaleString());
    return parts.join(" ");
  }

  return (
    <svg x="0" y="0" height={`${height}px`} width={`${maxTextWidth + 15}px`}>
      {entries.map((entry, i) => (
        <g
          transform={`translate(0,${entryHeight * i})`}
          key={`${entry.label}-${i}`}
        >
          <rect
            color={entry.color}
            opacity={!isNaN(entry.opacity) ? entry.opacity : 1}
            x="0"
            y="0"
            width="10"
            height="10"
          />
          <text
            key={`${entry.quantity}-label`}
            x="15"
            y={`${entryHeight / 2}`}
            fontFamily={fontFamily}
            fontSize={`${fontSize}px`}
          >
            {renderLabel(entry, i)}
          </text>
        </g>
      ))}
    </svg>
  );
}
